module.exports = __webpack_public_path__ + "img/special7.e7189260.png";